import './GroupTop.css';

import React from 'react';
import PropTypes from 'prop-types';

import Team from '@views/Team';

import { Row, Col } from 'antd';

export const GroupTop = ({
  firstTeam,
  secondTeam,
  firstAssertions,
  secondAssertions
}) => (
  <div className="GroupTop">
    <Row>
      <Col xs={24}>
        <h4>Clasificados</h4>
      </Col>
    </Row>
    <Row gutter={4}>
      <Col xs={12} className={`teamCol ${firstAssertions.join(' ')}`}>
        <div>
          <span className="position">1°</span>
          {firstTeam ? <Team code={firstTeam} /> : <span className="group-top-placeholder">A definir</span>}
        </div>
      </Col>
      <Col xs={12} className={`teamCol ${secondAssertions.join(' ')}`}>
        <div>
          <span className="position">2°</span>
          {secondTeam ? <Team code={secondTeam} /> : <span className="group-top-placeholder">A definir</span>}
        </div>
      </Col>
    </Row>
  </div>
);

GroupTop.displayName = 'GroupTop';
GroupTop.propTypes = {
  firstTeam: PropTypes.string,
  secondTeam: PropTypes.string,
  firstAssertions: PropTypes.arrayOf(PropTypes.string),
  secondAssertions: PropTypes.arrayOf(PropTypes.string)
};
GroupTop.defaultProps = {
  firstAssertions: [],
  secondAssertions: []
};

export default GroupTop;
